<span class="container" [class.erred]="erred" [class.loading]="loading">
  <i class="indicator" [class.loading]="loading"></i>
  <span>{{
    erred ? 'Auto-save failed' : loading ? 'Auto-saving' : 'Auto-saved'
  }}</span>
</span>
